import React from "react";
import actionButtonTick from "../../assets/images/icons/actionButtonTick.svg";
function ServiceUsersOptionsBlocks({ blockIcon, heading, linkedComponent, reportDone }) {
  return (
    <>

      <div className={`cards position-relative ${reportDone ? 'reportDone' : 'reportNotDone'}`} onClick={linkedComponent}>
        <div className="cardContent">
          <span className="contentIcon">
            <img src={blockIcon} alt={heading} />
          </span>
          <h3>{heading}</h3>
        </div>
      </div>
    </>
  );
}

export default ServiceUsersOptionsBlocks;
